/**
 * Constantes pour la propriété status (RFP Status)
 * Source: AbstractRfpModel.java - PARTNERRFP_STATUS_*
 */

export enum PartnerRfpStatusConstant {
    WITHHELD = 1,
    REJECTED = 2,
    ACCEPTED = 12,
    DELETED_AFTER_REJECTION = 56
}
